.container {
    padding: 16px;
    border-radius: 4px;
    border: 1px solid var(--off-white-dk);
}
